import React, { useState, useEffect } from "react";
import { LoaderButton } from "ctia-ui";
import { connect } from "react-redux";
import { formatDate } from "helpers/DateHelper";
import { getFullName } from "helpers/UsersHelper";
import { renderNameWithFlag } from "containers/ControlPanel/Payments/RenderHelperATL";
import { fetchASCComments, postASCComment } from "actions/comments";
import { FormControl } from "react-bootstrap";

const CenterComments = ({
  companyId,
  centerName,
  flagCode,
  asc,
  comments,
  fetchASCComments,
  postASCComment
}) => {
  const [text, setText] = useState("");
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (companyId) {
      setLoading(true);
      fetchASCComments(companyId, asc.invoicingYear).then(() =>
        setLoading(false)
      );
    }
  }, [companyId, asc, fetchASCComments]);

  const onTextChange = event => {
    setText(event.target.value);
  };

  const onSubmit = () => {
    setLoading(true);
    postASCComment(companyId, asc.invoicingYear, text)
      .then(() => fetchASCComments(companyId, asc.invoicingYear))
      .then(() => {
        setText("");
        setLoading(false);
      });
  };

  const renderComments = () => {
    if (comments.data.length) {
      return comments.data.map((item, i) => {
        const postDate = formatDate(item.createdat);
        const submitter = getFullName(item.user);
        return (
          <div key={i}>
            <b>{submitter}</b> <i>({postDate})</i>:<p>{item.comment}</p>
          </div>
        );
      });
    }
    return null;
  };

  if (!comments) return null;

  const count = comments.pager.TOTALRECORDS || 0;

  return (
    <div>
      <h6>{renderNameWithFlag(centerName, flagCode, 18)}</h6>
      <h4>Comments ({count})</h4>
      {renderComments()}
      <FormControl
        componentClass="textarea"
        value={text}
        onChange={onTextChange}
        disabled={isLoading}
      />
      <LoaderButton
        bsStyle="primary"
        bsSize="small"
        text="Post comment"
        onClick={onSubmit}
        isLoading={isLoading}
        loadingText="Posting..."
        className="button-top-offset"
        disabled={text.length < 3}
      />
    </div>
  );
};

function mapStateToProps({ asc, comments }) {
  return { asc, comments };
}

export default connect(mapStateToProps, { fetchASCComments, postASCComment })(
  CenterComments
);
